import { render, staticRenderFns } from "./MantenedorGridSinCodigo.vue?vue&type=template&id=1d24bf99&"
import script from "./MantenedorGridSinCodigo.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGridSinCodigo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports